export default function PageHead({ children }) {
  return (
    <div className="content-xl flex items-center pb-2 pt-4 text-3xl font-bold">{children}</div>
  );
}
